// extracted by mini-css-extract-plugin
module.exports = {"mobileBreakpoint":"767","tabletBreakpoint":"1024","container":"styles_container__Ui4M_","text":"styles_text__32YW6","buttonContainer":"styles_buttonContainer__3Vg8_"};